import React, { useState } from 'react';
import { scrollDisable, scrollEnable } from '../func/scroll';
import SearchModal from '../view/components/Search/SearchModal';

export const SearchContext = React.createContext({});

function SearchProvider(props) {
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
    scrollDisable();
  };

  const handleCloseModal = () => {
    console.log('handleCloseModal');
    setOpenModal(false);
    scrollEnable();
  };

  return (
    <SearchContext.Provider value={{ handleOpenModal, handleCloseModal }}>
      {props.children}
      {openModal && <SearchModal closeModal={handleCloseModal} />}
    </SearchContext.Provider>
  );
}

export default SearchProvider;
